<div class="main_body">
  <app-page-header
    title="レコードダウンロード"
    i18n-title="@@adminSection.recordsDownloadRequestList.title.list"
    subtitle="記録データのダウンロードリクエストを管理します。"
    i18n-subtitle="@@adminSection.recordsDownloadRequestList.message.description"
    icon="download"
  />
  <div class="contents">
    <div class="contents_section_group">
      <section class="contents__section">
        <div class="dl-toolbar">
          <div class="dl-toolbar__actions">
            <button mat-stroked-button
                    class="dl-toolbar__btn"
                    (click)="createNewDownloadRequest()"
                    i18n="@@adminSection.recordsDownloadRequestList.button.newRequest">
              <mat-icon>add</mat-icon>
              <span>新規リクエスト</span>
            </button>
            <button mat-stroked-button
                    class="dl-toolbar__btn"
                    (click)="refreshData()"
                    i18n="@@adminSection.recordsDownloadRequestList.button.refresh">
              <mat-icon>refresh</mat-icon>
              <span>更新</span>
            </button>
          </div>
        </div>

        <div class="dl-content">
          @if (isLoading()) {
            <!-- Skeleton Loading -->
            @for (i of [1, 2, 3]; track i) {
              <div class="dl-card dl-card--skeleton">
                <div class="dl-card__header">
                  <div class="skeleton skeleton--icon"></div>
                  <div class="dl-card__title-area">
                    <div class="skeleton skeleton--title"></div>
                    <div class="skeleton skeleton--date"></div>
                  </div>
                  <div class="skeleton skeleton--badge"></div>
                </div>
                <div class="skeleton skeleton--conditions"></div>
              </div>
            }
          } @else if (downloadRequests && downloadRequests.length > 0) {
            @for (request of downloadRequests; track request.createdAt) {
              <div class="dl-card" [class.dl-card--expired]="!request.files || request.files.length === 0">
                <!-- Card Header -->
                <div class="dl-card__header">
                  <div class="dl-card__icon" [class.dl-card__icon--ready]="request.files && request.files.length > 0">
                    <mat-icon>cloud_download</mat-icon>
                  </div>
                  <div class="dl-card__title-area">
                    <span class="dl-card__title" i18n="@@adminSection.recordsDownloadRequestList.label.downloadRequest">
                      ダウンロードリクエスト
                    </span>
                    <span class="dl-card__date">{{ request.createdAt }}</span>
                  </div>
                  @if (request.files && request.files.length > 0) {
                    <span class="dl-card__badge dl-card__badge--ready">
                      <mat-icon>check_circle</mat-icon>
                      <span i18n="@@adminSection.recordsDownloadRequestList.status.ready">準備完了</span>
                    </span>
                  } @else {
                    <span class="dl-card__badge dl-card__badge--pending">
                      <mat-icon>schedule</mat-icon>
                      <span i18n="@@adminSection.recordsDownloadRequestList.status.processing">処理中</span>
                    </span>
                  }
                </div>

                <!-- Conditions -->
                <p class="dl-card__conditions">
                  <span i18n="@@adminSection.recordsDownloadRequestList.label.conditions">条件:</span>
                  {{ getConditions(request) }}
                </p>

                <!-- Files Section -->
                @if (request.files && request.files.length > 0) {
                  <div class="dl-card__files">
                    <span class="dl-card__files-label" i18n="@@adminSection.recordsDownloadRequestList.label.availableFiles">
                      ダウンロード可能ファイル:
                    </span>
                    @for (file of request.files; track file) {
                      <a [href]="file" class="dl-card__file-link" target="_blank" rel="noopener">
                        <mat-icon>insert_drive_file</mat-icon>
                        <span>{{ getFilename(file) }}</span>
                        <mat-icon class="dl-card__download-icon">download</mat-icon>
                      </a>
                    }
                  </div>
                }
              </div>
            }
          } @else {
            <!-- Empty State Hint -->
            <div class="dl-empty-hint">
              <mat-icon>info</mat-icon>
              <span i18n="@@adminSection.recordsDownloadRequestList.message.noRequestsDescription">
                新規リクエストを作成してデータをダウンロードできます
              </span>
            </div>
          }
        </div>
      </section>
    </div>
  </div>
</div>
